import { Component, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/features/dfte-grid-view/config/data.service';
import { CloudExtractLoadService } from '../cloud-extract-load.service';
import { ConfigPopupComponent } from '../config-popup/config-popup.component';
import { ExtractFromLoadService } from "src/app/dcon-modules/extract-from-cloud/extract-from-load.service";
import { DconConfigAPI } from 'src/app/features/dfte-grid-view/config/config';
import { NotificationService } from 'src/app/shared/components/notification/notification.service';
@Component({
  selector: "app-select",
  templateUrl: "./select.component.html",
  styleUrls: ["./select.component.scss"],
})
export class SelectComponent implements OnInit {
  instanceList: any;
  selectedInstance: string;
  batchKey: string;
  extractBatchKey: string;

  public tracks = [];
  public configData = [];
  batchKeyDetails: any = [];
  batchKeyDetails1: any = [];
  showArray = [];
  fromTable: any;
  headText: string = '';
  constructor(
    public dialog: MatDialog,
    private celService: CloudExtractLoadService,
    private dataService: ExtractFromLoadService,
    private router: Router,
    private route: ActivatedRoute,
    private _data: DataService,
    private notification: NotificationService
  ) { }

  ngOnInit(): void {
    if (this.celService.projId == null) {
      this.router.navigate([""], { relativeTo: this.route });
    } else {
      this.extractBatchKey = this.celService.extractBatchKey;
      if (this.extractBatchKey != null) {
        this.fromTable = true;
        this.celService.fromTable = true;
        this.celService.batchKey = this.extractBatchKey;
        this.celService.getExtractBatchKeyDetails(this.extractBatchKey).subscribe(res => {
          this.batchKeyDetails = this.prepareObjSet(res.Batch_Key_Details);
          if (this.batchKeyDetails[0].batchstatus === "Cloud Extraction - Complete") {
            this.headText = "is Cloud Extraction - Complete";
          } else if (this.batchKeyDetails[0].batchstatus === "Workbook Extraction - Complete") {
            this.headText = "is Workbook Extraction - Complete";
          } else {
            this.headText = "is New";
          }
          this.getInstanceDetails(DconConfigAPI.API_VARIABLES.CLOUD);
          this.selectedInstance = null;
          this.getTracks(this.batchKeyDetails);
          this.setShowArray();
          this._data.apiCallInProgress = false;
          document.getElementById("overlay").style.display = "none";
        },error => {
            this._data.apiCallInProgress = false;
            document.getElementById("overlay").style.display = "none";
            this.notification.showError('Something went wrong!');
          });

      } else {
        this.fromTable = false;
        this.getInstanceDetails(DconConfigAPI.API_VARIABLES.CLOUD);
        this.getConfigDetails(DconConfigAPI.API_VARIABLES.Request_Type_Load);
        this.selectedInstance = null;
        this.batchKey = this.celService.batchKey;
      }
    }

  }

  getTracks(data) {
    data.forEach((element, index) => {
      this.tracks.push(element.track);
    });
    this.tracks = [...new Set(this.tracks)];
  }

  setShowArray() {
    this.tracks.forEach((index) => {
      this.showArray[index] = false;
    });
  }

  prepareObjSet(batchDetails) {
    const data = [];
    batchDetails.forEach(element => {
      const obj = JSON.parse(element.config_details);
      obj['saveStatus'] = false;
      if (obj.linedetail != null && obj.linedetail.length > 0) {
        obj.linedetail.forEach(element => {
          if (element.taskselected === 'Y') {
            obj['saveStatus'] = true;
          }
        });
      }
      data.push(obj);
    });
    return data;
  }

  onInstanceChange(instance) {

  }

  configPopUp(data) {
    const dialogRef = this.dialog.open(ConfigPopupComponent, {
      width: "927px",
      height: "620px",
      data: {
        configData: Object.assign({}, data),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.celService.instanceName = this.selectedInstance;
      this.celService.instanceList = this.instanceList;
      if (result.savedData) {
        this.setSelectedconfigData(result, this.configData);
        this.celService.configObj = {
          tracks: this.tracks,
          configData: this.configData,
        };
        if (result.selectedConfigData.saveStatus) {
          this.celService.tabval.next("submit");
          this.router.navigate(["../submit"], { relativeTo: this.route });
        }
      } else {
        this.celService.configObj = {
          tracks: this.tracks,
          configData: this.configData,
        };
      }
    });
  }

  setSelectedconfigData(result, configObj) {
    const selConfigData = result.selectedConfigData;
    configObj.forEach((element, index) => {
      if (selConfigData.TRACK === element.TRACK && selConfigData.APPLICATION_SHORT_CODE === element.APPLICATION_SHORT_CODE) {
        // selConfigData.saveStatus = true;
        this.configData.splice(index, 1, selConfigData);
      }
    });

  }

  getConfigDetails(type) {
    const data = [];
    this.celService.getConfigDetails(type).subscribe((res) => {
      res?.Config_Details?.forEach((element) => {
        let task = [];
        const obj = JSON.parse(element.details);
        if (obj.TASK != null) {
          obj.TASK.forEach((ele) => {
            const taskObj = ele;
            taskObj["selectStatus"] = "n";
            task.push(taskObj);
          });
        } else {
          task = null;
        }
        const detailsObj = {
          TRACK: obj.TRACK,
          APPLICATION: obj.APPLICATION,
          APPLICATION_SHORT_CODE: obj.APPLICATION_SHORT_CODE,
          saveStatus: false,
          TASK: task,
        };
        data.push(detailsObj);
      });
      this.configData = data;
      // console.log("data", data);
      data.forEach((element, index) => {
        this.tracks.push(element.TRACK);
        this.showArray[index] = false;
      });
      this.tracks = [...new Set(this.tracks)];
      this._data.apiCallInProgress = false;
      document.getElementById("overlay").style.display = "none";
    }, error => {
      this.notification.showError('Something went wrong!');
    });
  }


  getInstanceDetails(type) {
    const data = [];
    this.celService.getInstanceDetails(type).subscribe((res) => {
      res?.Instance_Details?.forEach((element) => {
        data.push(JSON.parse(element.details));
      });
      this.instanceList = data[0].INSTANCE;
    }, error => {
      this.notification.showError('Something went wrong!');
    });
  }

  configPopUpEdit(evt, data) {
    evt.stopPropagation();
    const dialogRef = this.dialog.open(ConfigPopupComponent, {
      width: "927px",
      height: "620px",
      data: {
        configData: Object.assign({}, data),
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.celService.instanceName = this.selectedInstance;
      this.celService.instanceList = this.instanceList;
      if (result.savedData) {
        this.setSelectedconfigDataEdit(result, this.batchKeyDetails);
        this.celService.tracksFromTable = this.tracks;
          this.celService.batchKeyDetails = this.batchKeyDetails;
        this.celService.tabval.next("submit");
        this.router.navigate(["../submit"], { relativeTo: this.route });
      } else {
        this.celService.tracksFromTable = this.tracks;
          this.celService.batchKeyDetails = this.batchKeyDetails;
      }
    });
  }

  setSelectedconfigDataEdit(result, configObj) {
    const selConfigData = result.selectedConfigData;
    configObj.forEach((element, index) => {
      if (selConfigData.track === element.track && selConfigData.applicationshortcode === element.applicationshortcode) {
        // selConfigData.saveStatus = true;
        this.batchKeyDetails.splice(index, 1, selConfigData);
      }
    });
  }

  
}
